module.exports = __webpack_public_path__ + "img/hourglass-illustration.e7db0bd9.svg";